module.exports = "data:audio/mpeg;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJtZWRpYS9kZWVwLWJyZWF0aGluZy5tcDMiOw=="